import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { Tooltip } from 'antd'
import IconOpen from '../common/IconOpen'
import Icon from './decorators/Icon'
import Info from './decorators/Info'
import Title from './decorators/Title'
import { OpModelStyled } from './styles'

const OpModelLayout = ({
  icon,
  title,
  text,
  onClick,
}: {
  icon: string
  title: string
  text: string
  onClick: () => void
}) => {
  const {
    copies: { header: copy },
    colorSubheader: color,
    showChooseOpModelMessage,
    site,
  } = useHeaderContext()

  return (
    <Tooltip
      title={copy?.chooseOpModelMessage}
      placement="bottom"
      trigger={[]}
      open={showChooseOpModelMessage}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement || triggerNode
      }
    >
      <OpModelStyled onClick={onClick} color={color}>
        {icon && <Icon icon={icon} />}
        <span className="location">
          {title && <Title title={title} />}
          {text && <Info text={text} />}
        </span>
        {site !== 'sales' && <IconOpen />}
      </OpModelStyled>
    </Tooltip>
  )
}

export default OpModelLayout
